<template>
    <div class="container-fluid root-component">
        <h2 class="text-center">{{ msg ? atob(msg) : 'Loading...' }}</h2>

        <div class="spinner">
            <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
        </div>

        <router-view :key="$route.fullPath"></router-view>
    </div>
</template>

<script>
    export default {
        props: ['msg'],

        methods: {
            atob(msg) {
                return window.atob(msg);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/_variables.scss';

    h2 {
        position: relative;
        z-index: 1001;
    }

    .spinner {
        position: fixed;
        width: 100%;
        height: 100%;
        text-align: center;
        background-color: $body-bg;
        z-index: 1000;
        left: 0;
        top: 0;

        .spinner-border {
            position: relative;
            top: 40%;
            width: 8rem;
            height: 8rem;
            color: #36a8cd;
        }
    }
</style>